import { authGet } from '../ajax';

const signalR = require('@microsoft/signalr');

export async function StartSignalR() {
    try {
        // console.log('[SignalR] Requesting authentication token...');
        var resp = await authGet("/Notification/SignalRToken");
        var token = await resp.text();

        // console.log('[SignalR] Token received, building connection...');
        // console.log('[SignalR] Connecting to:', global.SignalRUrl);

        var options = {
            accessTokenFactory: () => token
        };

        var connection = new signalR.HubConnectionBuilder()
            .withUrl(global.SignalRUrl, options)
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: retryContext => {
                    // Retry after 0, 2, 10, 30 seconds, then every 60 seconds
                    if (retryContext.previousRetryCount === 0) return 0;
                    if (retryContext.previousRetryCount === 1) return 2000;
                    if (retryContext.previousRetryCount === 2) return 10000;
                    if (retryContext.previousRetryCount === 3) return 30000;
                    return 60000;
                }
            })
            .configureLogging(signalR.LogLevel.Information)
            .build();

        // Connection event handlers
        connection.onreconnecting((error) => {
            console.warn('[SignalR] Connection lost. Reconnecting...', error);
        });

        connection.onreconnected((connectionId) => {
            console.log('[SignalR] Reconnected successfully. ConnectionId:', connectionId);
        });

        connection.onclose((error) => {
            console.error('[SignalR] Connection closed:', error);
            // Attempt to restart after 5 seconds
            setTimeout(() => {
                console.log('[SignalR] Attempting to restart connection...');
                StartSignalR();
            }, 5000);
        });

        await connection.start();
        // console.log('[SignalR] Connection established successfully');
        // console.log('[SignalR] Connection State:', connection.state);

        global.SignalRConnection = connection;

        // console.log('[SignalR] Connection is ready. Handlers should be registered by individual components.');

    } catch (error) {
        console.error('[SignalR] Failed to start connection:', error);
        // Retry after 10 seconds
        setTimeout(() => {
            console.log('[SignalR] Retrying connection after error...');
            StartSignalR();
        }, 10000);
    }
}